import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function SignoutCallbackComponent({ userManager, userAuthenticationService }) {
  const navigate = useNavigate();

  useEffect(() => {
    const onRedirectSuccess = (/* user */) => {
      // Ensure app state is logged out even if IdP signout is a no-op
      try {
        userAuthenticationService?.setUser?.(null);
      } catch (e) {
        // no-op
      }

      // Don't restore the last private route (often /viewer) after signout.
      // Instead, always land on /login for a clean logged-out state.
      try {
        sessionStorage.removeItem('ohif-redirect-to');
      } catch (e) {
        // no-op
      }

      const authority = userManager?.settings?.authority;
      const loginPath = authority
        ? `/login?iss=${encodeURIComponent(authority)}`
        : '/login';

      navigate(loginPath);
    };

    const onRedirectError = error => {
      throw new Error(error);
    };

    userManager
      .signoutRedirectCallback()
      .then(async user => {
        try {
          await userManager.removeUser?.();
          await userManager.clearStaleState?.();
        } catch (e) {
          // no-op
        }
        onRedirectSuccess(user);
      })
      .catch(error => onRedirectError(error));
  }, [navigate, userManager, userAuthenticationService]);

  return null;
}

SignoutCallbackComponent.propTypes = {
  userManager: PropTypes.object.isRequired,
  userAuthenticationService: PropTypes.object,
};

export default SignoutCallbackComponent;
